module.exports = __webpack_public_path__ + "static/media/matter-leatherworking-tool.00e15786.webp";